import { defineMessages } from 'react-intl'

export const lang = defineMessages({
  showAll: {
    id: 'donater.payment_type.show_all',
    defaultMessage: 'Show All',
  },
})
